import Axios from "../util/axiosInstance";


export const postProposal = (payload) => {
  return Axios.post("/api/TalentJobCenter/SubmitProposal", payload);
};
export const getProposal = (jobId) => {
  return Axios.get(`/api/TalentJobCenter/GetProposal?projectid=${jobId}`)
}